/**
 * 资格认证考试
 */
import { Toast } from 'antd-mobile';
import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';

export default {
  namespace: 'knowLedgeAuthTest',
  state: {
    list: [], // 考题
    disabled: true, // 提交按钮状态
    errorStatus: false, // 考试异常
    errorTips: '', // 考试异常提示
    examRule: {}, // 考试规则
    uuid: '', // 盟友考试记录uuid
  },
  reducers: {
    setList(state, action) {
      return {
        ...state,
        list: action.payload,
      };
    },
    setDisabled(state, action) {
      return {
        ...state,
        disabled: action.payload,
      };
    },
    setErrorStatus(state, action) {
      return {
        ...state,
        errorStatus: action.payload,
      };
    },
    setErrorTips(state, action) {
      return {
        ...state,
        errorTips: action.payload,
      };
    },
    setExamRule(state, action) {
      return {
        ...state,
        examRule: action.payload,
      };
    },
    setExamUuid(state, action) {
      return {
        ...state,
        uuid: action.payload,
      };
    },
    resetState() {
      return {
        list: [],
        disabled: true, // 提交按钮状态
        errorStatus: false, // 考试异常
        errorTips: '', // 考试异常提示
        examRule: {}, // 考试规则
        uuid: '', // 盟友考试记录uuid
      };
    },
  },
  effects: {
    // 获取考题数据
    *getAuthTestInfo(action, { put }) {
      Toast.loading('加载中...', 0);
      const { id } = action.payload;
      let params = { certificaId: id };
      const res = yield fetch.get(API.KNOLEDGE_AUTH_TEST_START, params);
      if (!res.errorType) {
        yield put({
          type: 'setList',
          payload: res.data.examQuestionBanks,
        });
        yield put({
          type: 'setExamRule',
          payload: res.data.examRule,
        });
        yield put({
          type: 'setExamUuid',
          payload: res.data.uuid,
        });
        yield put({
          type: 'setErrorStatus',
          payload: false,
        });
        yield put({
          type: 'setErrorTips',
          payload: '',
        });
        Toast.hide();
      } else {
        yield put({
          type: 'setErrorStatus',
          payload: true,
        });
        yield put({
          type: 'setErrorTips',
          payload: res.message,
        });
        Toast.hide();
      }
    },
    // 提交
    *testSubmit(action, { select }) {
      Toast.loading('提交中...', 0);
      const { list, examRule, uuid } = yield select(state => state.knowLedgeAuthTest);
      const { callBack = () => {} } = action.payload;
      let trueCount = 0;
      list.forEach(item => {
        if (item.myAns === item.trueAns) {
          trueCount += 1;
        }
      });
      const res = yield fetch.post(API.KNOLEDGE_AUTH_TEST_END, {
        examRule,
        trueCount,
        uuid,
      });
      if (!res.errorType) {
        Toast.success(res.data.msg, 3, () => {
          callBack();
        });
      } else {
        Toast.fail(res.message);
      }
    },
  },
};
